var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { transformProject } from '@freelancer/datastore/projects/projects.transformers';
export function transformAllProjects(project, context) {
    return __assign({}, transformProject(project), { bidAwardStatus: context.bidAwardStatus, bidCompleteStatus: context.bidCompleteStatus, unlistedProjects: context.unlistedProjects, searchProjectStatus: context.searchProjectStatus });
}
